import { TABLE_INFO } from "../shared/table_config";
import Tooltip from '@mui/material/Tooltip';
 
const { PROPS } = TABLE_INFO.TOP_MISCONFIGURATIONS;
interface ParameterCellProps {
  data: {
    [PROPS.PARAMETER]: string;
  };
}
 
const ParameterCellRenderer = (params: ParameterCellProps) => {
  
  return (
    <div className="security-parameter">
      <Tooltip
        title={params.data[PROPS.PARAMETER]}
        arrow
        slotProps={{
          tooltip: {
            sx: {
              backgroundColor: "#fff",
              color: "#000",
              boxShadow: 1,
              fontSize: "0.775rem",
            },
          },
          arrow: {
            sx: {
              color: "#fff",
            },
          },
        }}
      >
        <p className="text_ellipsis parameter-value">
          {params.data[PROPS.PARAMETER]}
        </p>
      </Tooltip>
 
    </div>
  );
};
 
export default ParameterCellRenderer;
 
 